<div class="flex flex-col mt-5" *ngIf="company">
	<app-input
		label="Name"
		name="name"
		type="text"
		[required]="true"
		[ngModel]="company?.name"
		[submitted]="true"
		[capitalizeInput]="true"
		(ngModelChange)="setCompanyName($event)"
	></app-input>
</div>
